module.exports = __webpack_public_path__ + "static/media/item_2_7ll.2990704d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/report/item_2_7ll.png
// module id = 124
// module chunks = 0